import { Button, Checkbox, Input, Modal, message } from 'antd';
import React, { useState } from 'react';
import PublicService from '../../../../services/publicService';
import EmployeeService from '../../../../services/EmployeeService';
import Terms from './terms';
import Policy from './privacy';

const OtpSection = (props) => {
    const { setShowSuccess, verifyData, setVerifyData } = props;
    const [showTerms, setShowTerms] = useState(false);
    const [showPrivacy, setShowPrivacy] = useState(false);

    const onUpdateChange = (e) => {
        const currentData = { ...verifyData };
        currentData[e.target.name] = e.target.value;
        setVerifyData(currentData);
    };
    const onSignUp = async () => {
        if(!verifyData.email || !verifyData.email_otp) {
            message.warning("Please enter email id and OTP");
        } else {
           PublicService.verifyEmployees(verifyData).then((res)=>{
                if(res.err) {
                    message.error(res.msg);
                } else {
                    message.success("Successfully verified");
                    setShowSuccess(2);
                }
            })
        }

    };
    const onTermChange = (e) => {
        const currentData = { ...verifyData };
        currentData[e.target.id] = e.target.checked;
        setVerifyData(currentData);
    }
    const onResedOtp = () => {
        EmployeeService.resend_otp({email: verifyData.email}).then((res)=>{
            if(res){
              message.success("OTP resend successfully");
            }
          }).catch((e)=>{
            message.error(e?.response?.data?.msg);
          });
    };
    return <div className="right_item">
        <div className="pubheader_sec">
            <div className="pub_title">Welcome to FoodLuv</div>
            <h3 className="sub_title">Verify your account</h3>
            <div className="logo_sec"><img src="/images/login_icon.png" alt="" /></div>
        </div>
        <div className='w-full'>
            <div className="password_sec w-full">
                <label>Email</label>
                <Input className="w-full" name="email" onChange={onUpdateChange} value={verifyData.email} />
            </div>
            <div className="password_sec w-full">
                <label>OTP</label>
                <Input className="w-full" name="email_otp" onChange={onUpdateChange} value={verifyData.email_otp} />
            </div>
            <div className="terms_sec">
                <div className='term_checkbox'>
                    <Checkbox checked={verifyData.is_terms_agreed} onChange={onTermChange} id="is_terms_agreed">Agree to the </Checkbox>
                    <span className='term_link' onClick={()=> setShowTerms(true)}>Terms and Condition</span>
                </div>
                <div className='term_checkbox'>
                    <Checkbox checked={verifyData.is_privacy_agreed} id="is_privacy_agreed" onChange={onTermChange}>Agree to the </Checkbox>
                    <span className='term_link' onClick={()=> setShowPrivacy(true)}>Privacy Policy</span>
                </div>    
            </div>
        </div>
        <div className="otp_btns">
            <Button type="primary" className='otp_signup' disabled={!verifyData.is_terms_agreed || !verifyData.is_privacy_agreed} onClick={onSignUp}>Sign Up</Button>
            <Button type="text" danger className="otp_resend" onClick={onResedOtp}>Resend OTP</Button>
        </div>
        <Modal visible={showTerms} onCancel={()=>{setShowTerms(false);}} title="Terms and Condition" footer={null}>
            <Terms />
        </Modal>
        <Modal visible={showPrivacy} onCancel={()=>{setShowPrivacy(false);}} title="Privacy Policy" footer={null}>
            <Policy />
        </Modal>
    </div>
};
 export default OtpSection;